import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import './style.scss';
const ZelleImageFlip1 = () => {
    const data = useStaticQuery(graphql`
        query ProductZelleFlip1 {
            file(relativePath: { eq: "xelle-flip-1.png" }) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                }
            }
        }
    `);

    const image = getImage(data.file);

    return (
        <GatsbyImage image={image} className="front" alt="Checkbook image" />
    );
};

export default ZelleImageFlip1;
